module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-lg-3">\n    <div class="team-card">\n        <span class=\'team-name\'>' +
((__t = ( name )) == null ? '' : __t) +
'</span>\n        <img class=\'team-img\' src="http://www.gravatar.com/avatar/' +
((__t = ( avatar )) == null ? '' : __t) +
'?s=100"/>\n        ';
 if (website) { ;
__p += '<span class=\'website\'><a href="' +
((__t = ( website )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( website )) == null ? '' : __t) +
'</a></span>';
 } ;
__p += '\n        ';
 if (email) { ;
__p += '<span class=\'email\'>' +
((__t = ( email )) == null ? '' : __t) +
'</span>';
 } ;
__p += '\n        ';
 if (twitter) { ;
__p += '<a href="https://twitter.com/' +
((__t = ( twitter )) == null ? '' : __t) +
'" class="twitter-follow-button" data-show-count="false">@' +
((__t = ( twitter )) == null ? '' : __t) +
'</a>';
 } ;
__p += '\n    </div>\n</div>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/team-card.html
// module id = 145
// module chunks = 0